export default __webpack_public_path__ + "static/media/AIPStatusComplete.8aa5a37c.png";